import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useAccess } from '@/shared/rbac'
import { useAuthStore } from '@/shared/stores/auth.store'
import type { TourAccessContext } from '../types'
import { useWalkthroughStore } from '../stores/walkthrough.store'
import { TOURS, pageTourFor } from '../lib/tours'
import { filterSteps } from '../utils/eligibility'

/** The existing access logic, packaged for step eligibility. */
export function useTourContext(): TourAccessContext {
  const access = useAccess()
  const has3d = useAuthStore((s) => s.hasPermission3d)
  const navGroups = useWalkthroughStore((s) => s.navGroups)
  const userFeatures = useAuthStore((s) => s.user?.features)
  return useMemo(() => ({ access, has3d, navGroups, userFeatures }), [access, has3d, navGroups, userFeatures])
}

/** Page tour for the current route, or null when there is none / nothing eligible for this user. */
export function useCurrentPageTour() {
  const { pathname } = useLocation()
  const ctx = useTourContext()
  return useMemo(() => {
    const tour = pageTourFor(pathname)
    return tour && filterSteps(tour, ctx, TOURS).length > 0 ? tour : null
  }, [pathname, ctx])
}
